import { useEffect as c } from "react";
const i = (u, t) => {
  c(() => {
    !t || !u.current || (typeof t == "function" && t(u.current), typeof t == "object" && (t.current = u.current));
  }, [t, u]);
};
export {
  i as default
};
